module.exports = __webpack_public_path__ + "img/logo.486396a5.png";